module.exports = __webpack_public_path__ + "static/img/img-category-info.ff69952a.png";